// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSDetailHeaderButton_button--default__nA5jZ","icon-wrapper":"RSDetailHeaderButton_icon-wrapper__5nXt3","spin":"RSDetailHeaderButton_spin__ctvCC"};